import React from 'react'
import { useContext } from "react"
import { Grid, Card, CardContent, Typography, Box } from "@mui/material"
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import UserContextP from "Interfaces/Context"

interface PropsInterface {
    order: any
    color: string
}

const itemCardStyle = {
    borderRadius: 2,
    border: '1px solid #e2e8f0',
    bgcolor: '#ffffff',
    height: '100%',
    boxShadow: 'none'
}

const InformationDocument = (props: PropsInterface) => {
    const { order, color } = props
    const context = useContext(UserContextP)

    const totalLines = Number(order?.totalLines ?? 0)
    const discountPct = Number(order?.discount ?? 0)
    const discountValue = Math.round((totalLines * discountPct / 100) * 100) / 100
    const subtotal = Number(order?.subtotal ?? 0)
    const iva = Math.round((subtotal * 0.13) * 100) / 100
    const retention = Number(order?.retention ?? 0)
    const total = Number(order?.total ?? 0)

    const currency = process.env.REACT_APP_CURRENCY ?? '$'
    const fmt = (v: number) => `${currency} ${context.separatorMiles(v)}`

    return (
        <>
            <Grid item xs={12}>
                <Box
                    sx={{
                        bgcolor: color || '#112a56',
                        color: '#fff',
                        p: 1.5,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1
                    }}
                >
                    <ReceiptLongOutlinedIcon sx={{ fontSize: 19 }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: 0.3 }}>
                        Información del documento
                    </Typography>
                </Box>
            </Grid>

            {/* Total Líneas */}
            <Grid item xs={6}>
                <Card elevation={0} sx={itemCardStyle}>
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, display: 'block' }}>
                            Total Líneas
                        </Typography>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1e293b', mt: 0.3 }}>
                            {fmt(totalLines)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Descuento % */}
            <Grid item xs={6}>
                <Card elevation={0} sx={itemCardStyle}>
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, display: 'block' }}>
                            Descuento %
                        </Typography>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: discountPct > 0 ? '#15803d' : '#1e293b', mt: 0.3 }}>
                            {discountPct.toFixed(2)}%
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Descuento $ */}
            <Grid item xs={6}>
                <Card elevation={0} sx={itemCardStyle}>
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, display: 'block' }}>
                            Descuento $
                        </Typography>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: discountValue > 0 ? '#15803d' : '#1e293b', mt: 0.3 }}>
                            {fmt(discountValue)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Subtotal */}
            <Grid item xs={6}>
                <Card elevation={0} sx={itemCardStyle}>
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, display: 'block' }}>
                            Subtotal
                        </Typography>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1e293b', mt: 0.3 }}>
                            {fmt(subtotal)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* IVA */}
            <Grid item xs={6}>
                <Card elevation={0} sx={itemCardStyle}>
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, display: 'block' }}>
                            IVA (13%)
                        </Typography>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1e293b', mt: 0.3 }}>
                            {fmt(iva)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Retención */}
            <Grid item xs={6}>
                <Card elevation={0} sx={itemCardStyle}>
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, display: 'block' }}>
                            Retención
                        </Typography>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1e293b', mt: 0.3 }}>
                            {fmt(retention)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/* Total del documento (Full width highlight banner) */}
            <Grid item xs={12}>
                <Box
                    sx={{
                        p: 2,
                        mt: 0.5,
                        borderRadius: 2.5,
                        bgcolor: '#f0fdf4',
                        border: '1.5px solid #86efac',
                        textAlign: 'center'
                    }}
                >
                    <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: 0.8, fontWeight: 700, color: '#15803d' }}>
                        Total del documento
                    </Typography>
                    <Typography variant="h4" sx={{ fontWeight: 800, color: '#14532d', mt: 0.3 }}>
                        {fmt(total)}
                    </Typography>
                </Box>
            </Grid>
        </>
    )
}

export default InformationDocument